import { Button } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import ReactFlow, {
  Background,
  BackgroundVariant,
  Controls,
  MiniMap,
} from 'react-flow-renderer';
import { useNavigate, useParams } from 'react-router-dom';
import { diagramApi } from '../../api';
import { Navbar } from '../../components';
import NotFound from '../../components/NotFound';
import { getColor } from '../../styles/mixins';
import { FetchDiagramI } from '../../types/diagram';
import { EDGE_VARIANTS, NODE_VARIANTS } from '../DiagramEditor/components';
import {
  Body,
  DiagramBody,
  DiagramBodyName,
  DiagramBodyTitle,
  FlowDiagram,
} from './DiagramPublicView.styled';

const DiagramPublicView = () => {
  const urlParams = useParams();

  const diagramId = urlParams.diagramId || '';
  const navigate = useNavigate();
  const [diagram, setDiagram] = useState<FetchDiagramI>();
  const [notPublic, setNotPublic] = useState(false);

  const getDiagramData = async () => {
    await diagramApi
      .fetchPublicViewDiagram(diagramId)
      .then((res) => {
        if (res.status === 200) {
          setDiagram(res.data);
        }
      })
      .catch((err) => {
        setNotPublic(true);
        console.log(err);
      });
  };

  useEffect(() => {
    getDiagramData();
  }, []);

  const DiagramNavbar = () => (
    <DiagramBody>
      <DiagramBodyName>Querylizer</DiagramBodyName>
      <DiagramBodyTitle>
        {diagram ? diagram?.diagram_name : 'Public View'}
      </DiagramBodyTitle>
      <Button
        onClick={() => navigate(`/dashboard`)}
        size="xs"
        variant="filled"
        color="purple"
        radius="sm"
        style={{ float: 'right' }}
      >
        New Diagram
      </Button>
    </DiagramBody>
  );

  return (
    <>
      <Navbar NavbarChildComp={<DiagramNavbar />} />
      <Body>
        <FlowDiagram>
          {diagram && diagram.id !== '' ? (
            <ReactFlow
              elements={diagram.elements}
              onLoad={(instance) => setTimeout(() => instance.fitView(), 0)}
              nodeTypes={NODE_VARIANTS}
              edgeTypes={EDGE_VARIANTS}
              style={{
                height: '100%',
                width: '100%',
                zIndex: 0,
                border: '2px solid #e6e6e6',
              }}
              nodesConnectable={false}
            >
              <Background
                variant={BackgroundVariant.Dots}
                gap={28}
                size={2}
                color={getColor('gray', 200)}
              />
              <MiniMap
                nodeStrokeWidth={3}
                style={{ right: '0', left: '10px' }}
              />
              <Controls
                style={{ right: '10px', left: 'auto' }}
                showInteractive={false}
              />
            </ReactFlow>
          ) : null}
          {notPublic ? (
            <NotFound
              text={`Sorry :( the diagram you are trying to access is not public.`}
            />
          ) : null}
        </FlowDiagram>
      </Body>
    </>
  );
};

export default DiagramPublicView;
